var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-stepper"},[_c('div',{staticClass:"d-stepper-header d-flex"},_vm._l((_vm.steps),function(step){return _c('div',{key:step.id,staticClass:"d-title",class:{
				stepperTitle: step.id != _vm.currentStep,
				selectedStep: step.id == _vm.currentStep
			},on:{"click":function($event){return _vm.stepClicked(step.id)}}},[(step.status)?_c('div',{staticClass:"status-ball",class:{
					statusUncompleted: step.status == 'uncompleted',
					statusError: step.status == 'error'
				}}):_vm._e(),_vm._v(" "+_vm._s(step.title)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }